import React from 'react';
import { Flex, RemoteImage, useScreenSize } from '@banhala/ui-kit';

type ReviewImageProps = {
  images: string[];
  onPressImage?: (index: number) => void;
};

const IMAGE_GAP = 4;
const IMAGE_COUNT = 4;
const HORIZONTAL_PADDING = 16;

export const ReviewImage: React.FC<ReviewImageProps> = ({
  images,
  onPressImage,
}) => {
  const { width: screenWidth } = useScreenSize();

  if (images.length === 0) return null;

  const imageSize =
    (screenWidth - HORIZONTAL_PADDING * 2 - IMAGE_GAP * (IMAGE_COUNT - 1)) /
    IMAGE_COUNT;

  return (
    <Flex.Row gap={IMAGE_GAP}>
      {images.slice(0, IMAGE_COUNT).map((imageUrl, index) => (
        <Flex
          key={`review-image-${index}`}
          width={imageSize}
          height={imageSize}
          borderRadius={'small'}
          overflow={'hidden'}
          onPress={() => onPressImage?.(index)}
        >
          <RemoteImage uri={imageUrl} width={imageSize} height={imageSize} />
        </Flex>
      ))}
    </Flex.Row>
  );
};